import React, { useEffect, useState } from "react";

/**
 * Live countdown for a deal expires_at ISO string.
 * Displays Days Hours Minutes Seconds ticking every second.
 */
export default function CountdownTimer({ expiresAt, compact = false }) {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    if (!expiresAt) return;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [expiresAt]);

  if (!expiresAt) return null;

  const end = new Date(expiresAt).getTime();
  const diff = Math.max(0, end - now);
  const expired = diff <= 0;

  const totalSec = Math.floor(diff / 1000);
  const days = Math.floor(totalSec / 86400);
  const hours = Math.floor((totalSec % 86400) / 3600);
  const minutes = Math.floor((totalSec % 3600) / 60);
  const seconds = totalSec % 60;

  if (expired) {
    return (
      <span className="bhega-pill bg-[var(--bhega-error-soft)] text-[var(--bhega-error)]" data-testid="countdown-expired">
        Deal expired
      </span>
    );
  }

  if (compact) {
    return (
      <span className="inline-flex items-center gap-1 text-xs font-bold text-foreground" data-testid="countdown-compact">
        <span className="w-1.5 h-1.5 rounded-full bg-[var(--bhega-error)] animate-pulse" />
        {days > 0 ? `${days}d ` : ""}{String(hours).padStart(2, "0")}:{String(minutes).padStart(2, "0")}:{String(seconds).padStart(2, "0")}
      </span>
    );
  }

  return (
    <div className="inline-flex items-center gap-2" data-testid="countdown-full">
      <span className="w-2 h-2 rounded-full bg-[var(--bhega-error)] animate-pulse" />
      <span className="text-xs uppercase tracking-wider font-bold text-muted-foreground">Deal ends in</span>
      <div className="flex gap-1 items-center font-heading">
        {[
          { label: "D", v: days },
          { label: "H", v: hours },
          { label: "M", v: minutes },
          { label: "S", v: seconds },
        ].map((u, i) => (
          <React.Fragment key={u.label}>
            <span className="inline-flex flex-col items-center px-2 py-1 bg-card text-brand rounded-none min-w-[42px]">
              <span className="text-lg font-extrabold leading-none">{String(u.v).padStart(2, "0")}</span>
              <span className="text-xs uppercase tracking-widest text-foreground/60 mt-0.5">{u.label}</span>
            </span>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
